module.exports = __webpack_public_path__ + "static/media/exchange_instant.d8d34f04.png";